export default __webpack_public_path__ + "static/media/end_tb_logo.cc8f7584.png";